import React, { useState } from "react";
import {
  ConsensusRecommendationWidget,
  ConsensusRecommendationWidgetProps,
  Region,
  ThemeType,
  Type,
  WidgetError,
  WidgetMessage,
  WidgetHeightMessage,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";

const ConsensusRecommendation: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const region = queryParams.get("region") || "";
  const type = queryParams.get("type") || "";
  const token = queryParams.get("token") || "";
  const theme = queryParams.get("theme") || ThemeType.Direct;

  const handleCallback = (message: WidgetMessage) => {
    console.log("Bell received data from LabCI Widget:", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(message),
        "*",
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleNoData = (message: WidgetMessage) => {
    console.log("handleNoData", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.ConsensusRecommendation,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleHeightChange = (messages: WidgetHeightMessage) => {
    console.log("handleHeightChange", messages);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(messages));
      return;
    }
    window.parent.postMessage(JSON.stringify(messages), "*");
  };

  const props: ConsensusRecommendationWidgetProps = {
    region: region as Region,
    type: type as Type,
    token: token,
    onCallback: handleCallback,
    theme: theme as ThemeType,
    onNoData: handleNoData,
    onLoadingChange: handleLoadingChange,
    onError: handleError,
    onHeightChange: handleHeightChange,
  };

  return (
    <Spin
      wrapperClassName="widget-spin"
      spinning={isLoading}
      indicator={<CircularProgress theme={theme as ThemeType} />}
    >
      <ConsensusRecommendationWidget {...props} />
    </Spin>
  );
};

export default ConsensusRecommendation;
